import { __awaiter, __extends, __generator, __read } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Category, Credentials, PredictionsAction, getAmplifyUserAgentObject, } from '@aws-amplify/core';
import { AbstractInterpretPredictionsProvider } from '../types/Providers';
import { InterpretTextCategories, } from '../types';
import { ComprehendClient, DetectSyntaxCommand, DetectEntitiesCommand, DetectDominantLanguageCommand, DetectKeyPhrasesCommand, DetectSentimentCommand, } from '@aws-sdk/client-comprehend';
var AmazonAIInterpretPredictionsProvider = /** @class */ (function (_super) {
    __extends(AmazonAIInterpretPredictionsProvider, _super);
    function AmazonAIInterpretPredictionsProvider() {
        return _super.call(this) || this;
    }
    AmazonAIInterpretPredictionsProvider.prototype.getProviderName = function () {
        return 'AmazonAIInterpretPredictionsProvider';
    };
    AmazonAIInterpretPredictionsProvider.prototype.interpretText = function (input) {
        var _this = this;
        return new Promise(function (res, rej) { return __awaiter(_this, void 0, void 0, function () {
            var credentials, _a, _b, _c, region, _d, _e, interpretTypeConfig, _f, _g, _h, _j, text, _k, interpretType, _l, _m, _o, language, doAll, languagePromise, languageDetectionParams, entitiesPromise, LanguageCode, _p, entitiesDetectionParams, sentimentPromise, LanguageCode, _q, sentimentParams, syntaxPromise, LanguageCode, _r, syntaxParams, keyPhrasesPromise, LanguageCode, _s, keyPhrasesParams, results, err_1;
            return __generator(this, function (_t) {
                switch (_t.label) {
                    case 0: return [4 /*yield*/, Credentials.get()];
                    case 1:
                        credentials = _t.sent();
                        if (!credentials)
                            return [2 /*return*/, rej('No credentials')];
                        _a = this._config.interpretText, _b = _a === void 0 ? {} : _a, _c = _b.region, region = _c === void 0 ? '' : _c, _d = _b.defaults, _e = (_d === void 0 ? {} : _d).type, interpretTypeConfig = _e === void 0 ? '' : _e;
                        _f = (input).text, _g = _f === void 0 ? {} : _f, _h = _g.source, _j = (_h === void 0 ? {} : _h).text, text = _j === void 0 ? '' : _j, _k = _g.type, interpretType = _k === void 0 ? interpretTypeConfig : _k;
                        _l = (input).text, _m = (_l === void 0 ? {} : _l).source, _o = (_m === void 0 ? {} : _m).language, language = _o === void 0 ? undefined : _o;
                        this.comprehendClient = new ComprehendClient({
                            credentials: credentials,
                            region: region,
                            customUserAgent: getAmplifyUserAgentObject({
                                category: Category.Predictions,
                                action: PredictionsAction.Interpret,
                            }),
                        });
                        doAll = interpretType === InterpretTextCategories.ALL;
                        if (doAll || interpretType === InterpretTextCategories.LANGUAGE) {
                            languageDetectionParams = {
                                Text: text,
                            };
                            languagePromise = this.detectLanguage(languageDetectionParams);
                        }
                        if (!(doAll || interpretType === InterpretTextCategories.ENTITIES)) return [3 /*break*/, 4];
                        _p = language;
                        if (_p) return [3 /*break*/, 3];
                        return [4 /*yield*/, languagePromise];
                    case 2:
                        _p = (_t.sent());
                        _t.label = 3;
                    case 3:
                        LanguageCode = _p;
                        if (!LanguageCode) {
                            return [2 /*return*/, rej('language code is required on source for this selection')];
                        }
                        entitiesDetectionParams = {
                            Text: text,
                            LanguageCode: LanguageCode,
                        };
                        entitiesPromise = this.detectEntities(entitiesDetectionParams);
                        _t.label = 4;
                    case 4:
                        if (!(doAll || interpretType === InterpretTextCategories.SENTIMENT)) return [3 /*break*/, 7];
                        _q = language;
                        if (_q) return [3 /*break*/, 6];
                        return [4 /*yield*/, languagePromise];
                    case 5:
                        _q = (_t.sent());
                        _t.label = 6;
                    case 6:
                        LanguageCode = _q;
                        if (!LanguageCode) {
                            return [2 /*return*/, rej('language code is required on source for this selection')];
                        }
                        sentimentParams = {
                            Text: text,
                            LanguageCode: LanguageCode,
                        };
                        sentimentPromise = this.detectSentiment(sentimentParams);
                        _t.label = 7;
                    case 7:
                        if (!(doAll || interpretType === InterpretTextCategories.SYNTAX)) return [3 /*break*/, 10];
                        _r = language;
                        if (_r) return [3 /*break*/, 9];
                        return [4 /*yield*/, languagePromise];
                    case 8:
                        _r = (_t.sent());
                        _t.label = 9;
                    case 9:
                        LanguageCode = _r;
                        if (!LanguageCode) {
                            return [2 /*return*/, rej('language code is required on source for this selection')];
                        }
                        syntaxParams = {
                            Text: text,
                            LanguageCode: LanguageCode,
                        };
                        syntaxPromise = this.detectSyntax(syntaxParams);
                        _t.label = 10;
                    case 10:
                        if (!(doAll || interpretType === InterpretTextCategories.KEY_PHRASES)) return [3 /*break*/, 13];
                        _s = language;
                        if (_s) return [3 /*break*/, 12];
                        return [4 /*yield*/, languagePromise];
                    case 11:
                        _s = (_t.sent());
                        _t.label = 12;
                    case 12:
                        LanguageCode = _s;
                        if (!LanguageCode) {
                            return [2 /*return*/, rej('language code is required on source for this selection')];
                        }
                        keyPhrasesParams = {
                            Text: text,
                            LanguageCode: LanguageCode,
                        };
                        keyPhrasesPromise = this.detectKeyPhrases(keyPhrasesParams);
                        _t.label = 13;
                    case 13:
                        _t.trys.push([13, 15, , 16]);
                        return [4 /*yield*/, Promise.all([
                                languagePromise,
                                entitiesPromise,
                                sentimentPromise,
                                syntaxPromise,
                                keyPhrasesPromise,
                            ])];
                    case 14:
                        results = _t.sent();
                        res({
                            textInterpretation: {
                                keyPhrases: results[4] || [],
                                language: results[0] || '',
                                sentiment: results[2],
                                syntax: results[3] || [],
                                textEntities: results[1] || [],
                            },
                        });
                        return [3 /*break*/, 16];
                    case 15:
                        err_1 = _t.sent();
                        rej(err_1);
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        }); });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectKeyPhrases = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detectKeyPhrasesCommand, data, _a, KeyPhrases, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        detectKeyPhrasesCommand = new DetectKeyPhrasesCommand(params);
                        return [4 /*yield*/, this.comprehendClient.send(detectKeyPhrasesCommand)];
                    case 1:
                        data = _b.sent();
                        _a = (data || {}).KeyPhrases, KeyPhrases = _a === void 0 ? [] : _a;
                        return [2 /*return*/, KeyPhrases.map(function (_a) {
                                var text = _a.Text;
                                return { text: text };
                            })];
                    case 2:
                        err_2 = _b.sent();
                        if (err_2.code === 'AccessDeniedException') {
                            Promise.reject('Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: ' +
                                'amplify predictions add');
                        }
                        else {
                            Promise.reject(err_2.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectSyntax = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detectSyntaxCommand, data, _a, SyntaxTokens, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        detectSyntaxCommand = new DetectSyntaxCommand(params);
                        return [4 /*yield*/, this.comprehendClient.send(detectSyntaxCommand)];
                    case 1:
                        data = _b.sent();
                        _a = (data || {}).SyntaxTokens, SyntaxTokens = _a === void 0 ? [] : _a;
                        return [2 /*return*/, this.serializeSyntaxFromComprehend(SyntaxTokens)];
                    case 2:
                        err_3 = _b.sent();
                        if (err_3.code === 'AccessDeniedException') {
                            Promise.reject('Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: ' +
                                'amplify predictions add');
                        }
                        else {
                            Promise.reject(err_3.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.serializeSyntaxFromComprehend = function (tokens) {
        var response = [];
        if (tokens && Array.isArray(tokens)) {
            response = tokens.map(function (_a) {
                var _b = _a.Text, text = _b === void 0 ? '' : _b, _c = _a.PartOfSpeech, _d = (_c === void 0 ? {} : _c).Tag, syntax = _d === void 0 ? '' : _d;
                return { text: text, syntax: syntax };
            });
        }
        return response;
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectSentiment = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detectSentimentCommand, data, _a, _b, predominant, _c, _d, _e, positive, _f, negative, _g, neutral, _h, mixed, err_4;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _j.trys.push([0, 2, , 3]);
                        detectSentimentCommand = new DetectSentimentCommand(params);
                        return [4 /*yield*/, this.comprehendClient.send(detectSentimentCommand)];
                    case 1:
                        data = _j.sent();
                        _a = (data), _b = _a.Sentiment, predominant = _b === void 0 ? '' : _b, _c = _a.SentimentScore, _d = _c === void 0 ? {} : _c, _e = _d.Positive, positive = _e === void 0 ? 0 : _e, _f = _d.Negative, negative = _f === void 0 ? 0 : _f, _g = _d.Neutral, neutral = _g === void 0 ? 0 : _g, _h = _d.Mixed, mixed = _h === void 0 ? 0 : _h;
                        return [2 /*return*/, { predominant: predominant, positive: positive, negative: negative, neutral: neutral, mixed: mixed }];
                    case 2:
                        err_4 = _j.sent();
                        if (err_4.code === 'AccessDeniedException') {
                            Promise.reject('Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: ' +
                                'amplify predictions add');
                        }
                        else {
                            Promise.reject(err_4.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectEntities = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detectEntitiesCommand, data, _a, Entities, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        detectEntitiesCommand = new DetectEntitiesCommand(params);
                        return [4 /*yield*/, this.comprehendClient.send(detectEntitiesCommand)];
                    case 1:
                        data = _b.sent();
                        _a = (data || {}).Entities, Entities = _a === void 0 ? [] : _a;
                        return [2 /*return*/, this.serializeEntitiesFromComprehend(Entities)];
                    case 2:
                        err_5 = _b.sent();
                        if (err_5.code === 'AccessDeniedException') {
                            Promise.reject('Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: ' +
                                'amplify predictions add');
                        }
                        else {
                            Promise.reject(err_5.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.serializeEntitiesFromComprehend = function (data) {
        var response = [];
        if (data && Array.isArray(data)) {
            response = data.map(function (_a) {
                var type = _a.Type, text = _a.Text;
                return { type: type, text: text };
            });
        }
        return response;
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectLanguage = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var detectDominantLanguageCommand, data, _a, _b, LanguageCode, err_6;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        detectDominantLanguageCommand = new DetectDominantLanguageCommand(params);
                        return [4 /*yield*/, this.comprehendClient.send(detectDominantLanguageCommand)];
                    case 1:
                        data = _c.sent();
                        _a = (data || {}).Languages, _b = __read(_a === void 0 ? [{}] : _a, 1), LanguageCode = _b[0].LanguageCode;
                        if (!LanguageCode) {
                            Promise.reject('Language not detected');
                        }
                        return [2 /*return*/, data.Languages[0].LanguageCode];
                    case 2:
                        err_6 = _c.sent();
                        if (err_6.code === 'AccessDeniedException') {
                            Promise.reject('Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: ' +
                                'amplify predictions add');
                        }
                        else {
                            Promise.reject(err_6.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AmazonAIInterpretPredictionsProvider;
}(AbstractInterpretPredictionsProvider));
export { AmazonAIInterpretPredictionsProvider };
//# sourceMappingURL=AmazonAIInterpretPredictionsProvider.js.map